import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/capillary_analytics_event.py
export const CAPILLARY_ANALYTICS_ACTIONS = {
  CALLED_TRY_IT_NOW: {
    module: ANALYTICS_MODULE.CAPILLARY,
    action: 'called_try_it_now',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
